import Security from "./Security.container";

export default Security;